import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { useUpdateEffect } from '@cian/react-utils';
import { SelectDropdown } from '../../../../internal/components/SelectDropdown';
import { CalendarPickerHeader } from './CalendarPickerHeader';
import { DayPicker } from './DayPicker';
import { YearPicker } from './YearPicker';
import { ECalendarPickerPage } from './types';
import { useCurrentDate } from './hooks';
import * as styles from './styles.module.css';
export function CalendarPicker(_ref) {
  var selected = _ref.selected,
    onChange = _ref.onChange,
    min = _ref.min,
    max = _ref.max;
  var _useCurrentDate = useCurrentDate(selected, min, max),
    _useCurrentDate2 = _slicedToArray(_useCurrentDate, 2),
    currentDate = _useCurrentDate2[0],
    setCurrentDate = _useCurrentDate2[1];
  var _React$useState = React.useState(ECalendarPickerPage.Month),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    page = _React$useState2[0],
    setPage = _React$useState2[1];
  var contentRef = React.useRef(null);
  var dayPickerRect = React.useRef({});
  useUpdateEffect(function () {
    setCurrentDate(selected || new Date());
  }, [selected], React.useEffect);
  React.useEffect(function () {
    var contentElement = contentRef.current;
    if (!contentElement) {
      return;
    }
    var rect = contentElement.getBoundingClientRect();
    dayPickerRect.current = {
      width: rect.width,
      height: rect.height
    };
  }, []);
  var handleChangeCurrentYear = function handleChangeCurrentYear(nextYear) {
    var nextCurrentDate = new Date(currentDate);
    nextCurrentDate.setFullYear(nextYear);
    setCurrentDate(nextCurrentDate);
    setPage(ECalendarPickerPage.Month);
  };
  var handleChangeYearClick = function handleChangeYearClick() {
    setPage(function (page) {
      return page === ECalendarPickerPage.Year ? ECalendarPickerPage.Month : ECalendarPickerPage.Year;
    });
  };
  var handlePrevMonthClick = function handlePrevMonthClick() {
    var nextCurrentDate = new Date(currentDate);
    nextCurrentDate.setMonth(nextCurrentDate.getMonth() - 1);
    setCurrentDate(nextCurrentDate);
  };
  var handleNextMonthClick = function handleNextMonthClick() {
    var nextCurrentDate = new Date(currentDate);
    nextCurrentDate.setMonth(nextCurrentDate.getMonth() + 1);
    setCurrentDate(nextCurrentDate);
  };
  return /*#__PURE__*/React.createElement(SelectDropdown, {
    onClose: function onClose() {}
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['calendar-picker']
  }, /*#__PURE__*/React.createElement(CalendarPickerHeader, {
    current: currentDate,
    min: min,
    max: max,
    page: page,
    onChangeYearClick: handleChangeYearClick,
    onPrevMonthClick: handlePrevMonthClick,
    onNextMonthClick: handleNextMonthClick
  }), /*#__PURE__*/React.createElement("div", {
    ref: contentRef,
    className: styles['content']
  }, page === ECalendarPickerPage.Month ? /*#__PURE__*/React.createElement(DayPicker, {
    selected: selected,
    month: currentDate,
    onChange: onChange,
    min: min,
    max: max
  }) : /*#__PURE__*/React.createElement(YearPicker, _extends({}, dayPickerRect.current, {
    selected: currentDate.getFullYear(),
    onChange: handleChangeCurrentYear,
    min: min && min.getFullYear(),
    max: max && max.getFullYear()
  })))));
}